import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

const actionsPrefix = 'app-job-search/seo';

export const INITIAL_STATE = {
  pageTitle: "",
  heading: null,
  pageDescription: "",
  robots: null,
  canonical: null,
  numberOfJobs: null
};

// setters (actions)
export const setNumberOfJobs = createAction(`${actionsPrefix}/SET_NUMBER_OF_JOBS`);
export const setPageTitle = createAction(`${actionsPrefix}/SET_PAGE_TITLE`);
export const setPageDescription = createAction(`${actionsPrefix}/SET_PAGE_DESCRIPTION`);
export const setRobots = createAction(`${actionsPrefix}/SET_ROBOTS`);
export const setCanonical = createAction(`${actionsPrefix}/SET_CANONICAL`);
export const setAll = createAction(`${actionsPrefix}/SET_ALL`);

// reducers state => newState
export default handleActions({
  [setAll]: (state, { payload: { SEOHeading, SEOPageTitle, SEOPageDescription, canonical, jobs: { metadata: { count } } } }) => ({
    ...state,
    pageTitle: SEOPageTitle,
    heading: SEOHeading,
    pageDescription: SEOPageDescription,
    numberOfJobs: count,
    canonical
  }),
  [setPageTitle]: (state, { payload: pageTitle }) => ({ ...state, pageTitle }),
  [setPageDescription]: (state, { payload: pageDescription }) => ({ ...state, pageDescription }),
  [setRobots]: (state, { payload: robots }) => ({ ...state, robots }),
  [setCanonical]: (state, { payload: canonical }) => ({ ...state, canonical })
}, INITIAL_STATE);

// getters (selectors)
export const get = state => state.seo;
export const getHeading = createSelector(get, ({ heading }) => heading);
export const getNumberOfJobs = createSelector(get, ({ numberOfJobs }) => numberOfJobs);
export const getPageTitle = createSelector(get, ({ pageTitle }) => pageTitle);
export const getPageDescription = createSelector(get, ({ pageDescription }) => pageDescription);
export const getRobots = createSelector(get, ({ robots }) => robots);
export const getCanonical = createSelector(get, ({ canonical }) => canonical);
